/* @flow */
// typecheck: ignore file
import React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import HoverLayerTrigger from 'components/HoverLayerTrigger.jsx';
import RelationshipActions from 'actions/RelationshipActions';
import RelationshipStore from 'stores/RelationshipStore';
import UserHovercard from 'users/components/UserHovercard.jsx';
import Relationship from 'entities/Relationship';
import Link from 'components/Link.jsx';

type Props = {
  children: any,
  userId: number,
  showSubscriptions?: boolean,
  neverShowStartChat?: boolean,
  placement: 'left' | 'right' | 'bottom' | 'top',
  alignment: 'top' | 'right' | 'bottom' | 'left',
}

type State = {
  relationship?: Relationship,
};

class UserLink extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [
      RelationshipStore,
    ];
  }

  static defaultProps = {
    neverShowStartChat: false,
  }

  static calculateState(_prevState: any, props: Props): State {
    return {
      relationship: RelationshipStore.getRelationship(props.userId),
    };
  }

  loadRelationship = () => {
    if (!this.state.relationship) {
      RelationshipActions.loadRelationship(this.props.userId);
    }
  }

  render() {
    const {
      neverShowStartChat,
      showSubscriptions,
      children,
      placement,
      alignment,
      ...props
    } = this.props;

    if (this.props.userId === CurrentUser.getUserId()) {
      return <Link {...props}>{children}</Link>;
    }

    const hovercard = (
      <UserHovercard
        relationship={this.state.relationship}
        neverShowStartChat={neverShowStartChat}
        showSubscriptions={showSubscriptions}
      />
    );

    return (
      <HoverLayerTrigger
        layer={hovercard}
        placement={placement}
        alignment={alignment}
        delayShow={400}>
        <Link {...props} onMouseEnter={this.loadRelationship}>{children}</Link>
      </HoverLayerTrigger>
    );
  }
}

export default Container.create(UserLink, { withProps: true });



// WEBPACK FOOTER //
// ./src/users/components/UserLink.jsx